// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"463":"c5b16c7f","700":"c1281c59"}[chunkId] + ".css";
};